export default "__VITE_ASSET__B0G8O3Gv__"